<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="close-subscription-period-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Close Subscription Period
                        </h4>
                    </div>

                    <div class="modal-body">
                        <number-form-group
                                v-model="data.credited_price"
                                name="credited_price"
                                label="Credited Price"
                                :error="getError('credited_price')"
                                help-text="The amount to credit for the subscription period."
                        ></number-form-group>

                        <date-form-group
                                v-model="data.ends_at"
                                name="ends_at"
                                label="New End Date"
                                :error="getError('ends_at')"
                                help-text="The date to set as the end date for the subscription period."
                                format="DD.MM.YYYY"
                        ></date-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
    import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'

    export default {
        components: {DateFormGroup, NumberFormGroup},

        mixins: [Errors],

        props: ['subscriptionPeriod'],

        data() {
            return {
                data: {}
            }
        },

        mounted() {
            this.listenForClose()
        },
        
        methods: {
            listenForClose() {
                $('#close-subscription-period-modal').on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.post('/api/v1/closed-subscription-periods', {...this.data, subscription_period_id: this.subscriptionPeriod.id})
                    .then(response => {
                        notify.success('The subscription period was closed')

                        this.$emit('closed', response.data.data)

                        $('#close-subscription-period-modal').modal('hide')
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.data = {}
            }
        }
    }
</script>
